import React from 'react'
import { Trans } from '@lingui/react'
import { useDispatch, useSelector } from 'react-redux'
import { redirect } from 'react-router-dom'
import { Button } from '@Infowijs-eng/component-library/components'
import { ArrowLeft } from '@Infowijs-eng/component-library/icons'
import signOut from '../actions/authentication/signOut'
import AppLinks from '../components/AppLinks'
import Layout from '../components/Layout'
import Header from '../components/Header'
import ErrorIcon from '../components/ErrorIcon'
import getRefreshToken from '../selectors/authentication/getRefreshToken'
import getName from '../selectors/customer/getName'
import getPremiumAppName from '../selectors/customer/getPremiumAppName'

function ForbiddenScreen() {
  const dispatch = useDispatch
  const refreshToken = useSelector(getRefreshToken)
  const customer = useSelector(getName)
  const customerPremiumAppName = useSelector(getPremiumAppName)

  if (!refreshToken) {
    redirect(`/${customer}`)
  }

  return (
    <Layout>
      <div className="text-center flex-grow self-center space-y-8">
        <ErrorIcon />
        <Header className="text-orange-500"><Trans id="no-access.title">Geen toegang</Trans></Header>
        <p className="font-bold text-lg">
          <Trans id="no-access.text" values={{ customerPremiumAppName: customerPremiumAppName || 'Hoy' }}>
            {'Als ouder of leerling heb je geen toegang tot de webversie van de {customerPremiumAppName} app.'}
          </Trans>
        </p>
        <p className="font-bold text-lg">
          <Trans id="no-access.download" values={{ customerPremiumAppName: customerPremiumAppName || 'Hoy' }}>
            {'Download nu de {customerPremiumAppName} app om in te loggen.'}
          </Trans>
        </p>
        <AppLinks />
        <Button
          onClick={() => {
            dispatch(signOut)
          }}
          className="mx-auto"
          leadingAddon={<ArrowLeft />}
        >
          <Trans id="no-access.back">Terug</Trans>
        </Button>
      </div>
    </Layout>
  )
}

export default ForbiddenScreen
